export const immutableAddOrUpdateObjectKey = (prevState, key, value) => {
    return {
        ...prevState,
        [key]: value
    }
}

export const immutableRemoveObjectKey = (prevState, key) => {
    const {
        [key]: removedProperty, ...remainingProperties
    } = prevState
    return remainingProperties
}

export const appendObjToArray = (array, obj) => array.concat(obj)

export const updateObjInArray = (array, obj) => {
    const tmp = [...array]
    const idx = array.findIndex(e => e.id === obj.id)
    tmp[idx] = obj
    return tmp
}

export const removeObjWithIdFromArray = (array, id) => array.filter(e => e.id !== id)

// ({
//     const tmp = [...array]
//     const idx = array.findIndex(e => e.id === id)
//     // ignore unfound IDs
//     if (idx > -1) {
//         tmp.splice(idx, 1)
//     }
//     return tmp
// }

export const swapUp = (array, idx) => {
    const tmp = [...array]
    const removed = tmp.splice(idx, 1)[0]
    tmp.splice(idx - 1, 0, removed)
    return tmp
}

export const swapDown = (array, idx) => {
    const tmp = [...array]
    const removed = tmp.splice(idx, 1)[0]
    tmp.splice(idx + 1, 0, removed)
    return tmp
}

// takes a list of objects and fieldName (key) and returns an object who's attributes are
// the distinct values for that field mapped to a list objects which share that
// value
export const groupByKey = (list, key) => list.reduce(
    (hash, obj) => ({
        ...hash,
        [obj[key]]: (hash[obj[key]] || []).concat(obj)
    }), {}
)
